import type { FC, ReactNode } from 'react'

import Starburst from '@/components/generals/starburst'
import ContactForm from '@/components/landing/contact-form'
import SectionLabel from '@/components/landing/section-label'
import { CONTACT_STEPS } from '@/constants/landing'

const ContactSection: FC = (): ReactNode => {
    return (
        <section id='contact' aria-labelledby='contact-title' className='bg-foreground text-background'>
            <div className='site-container py-24 md:py-36'>
                <SectionLabel index='06'>
                    New business
                </SectionLabel>

                <h2
                    id='contact-title'
                    className='reveal mt-6 font-heading text-[clamp(3.25rem,12.5vw,12.5rem)] leading-[0.82] font-black uppercase wdth-75'
                >
                    <span className='block'>
                        Let’s make
                    </span>

                    <span className='block text-primary'>
                        some noise
                        <Starburst className='ml-[0.1em] inline-block size-[0.6em] align-baseline motion-safe:animate-spin-slow' />
                    </span>
                </h2>

                <div className='mt-14 grid gap-12 md:mt-20 lg:grid-cols-12 lg:gap-16'>
                    <div className='lg:col-span-5'>
                        <p className='text-lg leading-relaxed text-background/80 md:text-xl'>
                            Tell us about the brand, the shelf it lives on and what’s keeping you up at night. A partner reads every brief, not an inbox robot.
                        </p>

                        <ol className='mt-10 space-y-6'>
                            {CONTACT_STEPS.map((step, index) => (
                                <li key={step.title} className='flex gap-4'>
                                    <span
                                        aria-hidden='true'
                                        className='grid size-10 shrink-0 place-items-center rounded-full bg-primary font-mono text-sm font-medium text-primary-foreground'
                                    >
                                        {index + 1}
                                    </span>

                                    <div>
                                        <p className='font-heading text-xl font-black uppercase wdth-90'>
                                            {step.title}
                                        </p>

                                        <p className='mt-1 leading-relaxed text-background/70'>
                                            {step.description}
                                        </p>
                                    </div>
                                </li>
                            ))}
                        </ol>

                        <dl className='mt-12 grid gap-6 border-t border-background/20 pt-8 sm:grid-cols-2'>
                            <div>
                                <dt className='font-mono text-xs tracking-[0.18em] text-background/60 uppercase'>
                                    Studio
                                </dt>

                                <dd className='mt-2 text-lg font-semibold'>
                                    Brooklyn, New York
                                </dd>
                            </div>

                            <div>
                                <dt className='font-mono text-xs tracking-[0.18em] text-background/60 uppercase'>
                                    Reply time
                                </dt>

                                <dd className='mt-2 text-lg font-semibold'>
                                    Within 2 working days
                                </dd>
                            </div>
                        </dl>
                    </div>

                    <div className='lg:col-span-7'>
                        <ContactForm />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactSection
